import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const themeDefault = 'light';
const themeAlt = 'dark';
// const theme = (window.location.href.includes('localhost') || window.location.href.includes('test')) && window.location.search.includes('alt') ? themeAlt : themeDefault;
const theme = themeDefault;

export default new Vuex.Store({
	state: {
		app: {
			showSpecialOffer: false,
			showSpecialOfferConfirmation: false,
			isTouchEnabled: false,
			theme: theme,
			orderNumber: '',
			session: '',
			myToyotaId: '', 
			loginLogged: false, 
			sessionTimeout: 900,
			myToyotaLink: 'https://www.toyota.com.au/mytoyota',
			cashDeposit: 1000, 
			tradeValuationEnabled: false, 
			referenceEnabled: false, 
			referrer: '', 
			financeDeposit: 0, 
			webkiosk: false, 
			tprSource: '', 
			disclaimers: []
		},
		tpr: {
			pegaCase: '',
			guestRateIdentifier: '', 
			validityDate: '',
			detailIdentifier: '', 
			tprEnabled: '', 
			isTprDown: ''
		},
        vehicle: {
			Materialcode: '',
			DriveawayPrice: '',
			Model: '',
			Grade: '',
			FullDescription: '',
			Transmission: '',
			Paint: '',
			Trim: '',
			FactoryOptionDescription: '',
			Disclaimer: '', 
			Image: ''
		},
		vehicleArray: [],
        dealer: {
			onlineOrderClosed: false, 
			dealerClosed: false, 
			locationName: '',
			dealerName: '',
			dealerMetroRural: '',
			branchCode: '',
			dealerID: 0,
			region: '',
			stockDealerID: 0,
			queryDealerID: 0,
			primaryDealerCode: 0,
			lmct: '',
			state: '',
			nviUrl: '',
			website: '',
			depositMinimum: 0,
			// cashDepositMaximum: 2000,
			callbackDays: [],
			openingHours: [],
			vehicleReturnGuarantee: false,
			privacyPolicy: '',
			storeWhyBuy: '',
			pricingZone: '',
			agent: {
				FirstName: '',
				LastName: '',
				Email: '',
				Phone: '',
				PhotoUrl: ''
			}
        },
		customer: {
			title: '', 
			firstName: '',
			lastName: '',
			email: '', 
			phoneNumber: '', 
			dateOfBirth: '', 
			address: {
				address: '',
				suburb: '',  
				postcode: '', 
				state: '',  
				unitNumber: '',
				streetNumber: '',  
				streetName: '',  
				streetType: '',  
			}, 
			acceptTerms: false
		},
		openModal: {
			id: '', 
			title: '',
			message: '', 
			buttons: []
		},
		loading: {
			show: true
		}
	},
	mutations: {
		setShowSpecialOffer(state, payload){
			state.app.showSpecialOffer = payload;
		},
		setShowSpecialOfferConfirmation(state, payload){
			state.app.showSpecialOfferConfirmation = payload;
		},
		setIsTouchEnabled(state, payload){
			state.app.isTouchEnabled = payload;
		},
		addDisclaimer(state, payload){
			(state.app.disclaimers as any).push(payload);
		},
		setDisclaimers(state, payload){
			Vue.set(state.app, 'disclaimers', [...payload]);
		},
		setOrderNumber(state, payload){
			state.app.orderNumber = payload;
		},
		setTpr(state, payload){
			state.tpr = {...state.tpr, ...payload};
		},
		setTprSource(state, payload){
            state.app.tprSource = payload;
        },
		// setApp(state, payload){
		// 	state.app = {...state.app, ...payload};
		// },
		setWebkiosk(state, payload){
			state.app.webkiosk = payload;
		},
		setAppFinanceDeposit(state, payload){
			state.app.financeDeposit = payload;
		},
		setReferrer(state, payload){
            state.app.referrer = payload;
        },
		setReferenceEnabled (state, payload){ 
			state.app.referenceEnabled = payload;
		},
		setTradeValuationEnabled (state, payload){ 
			state.app.tradeValuationEnabled = payload;
		},
		setVRG (state, payload) { 
			state.dealer.vehicleReturnGuarantee = payload;
		},
		setAgent (state, payload) {
			state.dealer.agent = {...state.dealer.agent, ...payload};
		},
		setStoreWhyBuy(state, payload){
			state.dealer.storeWhyBuy = payload;
		},
		setDealerClosed(state, payload){
			state.dealer.dealerClosed = payload.DealerClosed;
			state.dealer.onlineOrderClosed = payload.OnlineOrderClosed;
		},
		setOpeningHours(state, payload){ 
			Vue.set(state.dealer, 'openingHours', [...payload]);
		},
		setCallbackDays (state, payload){
			Vue.set(state.dealer, 'callbackDays', [...payload]);
		},
		setSession(state, payload){
			state.app.session = payload;
		}, 
		setMyToyotaId(state, payload){
			state.app.myToyotaId = payload;
		},
		setLoginLogged(state, payload){
			state.app.loginLogged = payload;
		},
		resetOpenModal(state){
			state.openModal.id = '';
			state.openModal.title = '';
			state.openModal.message = '';
			Vue.set(state.openModal, 'buttons', []);
		},
		setOpenModal(state, payload){
			state.openModal.id = payload.id;
			state.openModal.title = state.openModal.title ? payload.data.title : '';
			state.openModal.message = state.openModal.message ? payload.message : '';
			Vue.set(state.openModal, 'buttons', payload.buttons ? [...payload.buttons] : []);
		},
		setError(state, payload){
			if (state.openModal.id !== 'ErrorModal'){
				state.openModal = {...state.openModal, id: 'ErrorModal', ...payload};
			}
		},
		setLoading(state, payload){
			state.loading = {...state.loading, ...payload};
        }, 
		setCustomer(state, payload){
			state.customer = {...state.customer, ...payload};
		}, 
		setVehicle (state, payload) {
			state.vehicle = {...state.vehicle, ...payload};
		},
		setVehicleArray (state, payload) {
			Vue.set(state, 'vehicleArray', [...payload]);
        },
        setDealer (state, payload) {
			state.dealer = {...state.dealer, ...payload};
        },
	},
	actions: {
	},
	modules: {
	}
})
